import { render, staticRenderFns } from "./contract-review-qr-nl.vue?vue&type=template&id=74b2764c&scoped=true"
import script from "./contract-review-qr-nl.vue?vue&type=script&lang=js"
export * from "./contract-review-qr-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=74b2764c&prod&scoped=true&lang=css&external"
import style1 from "./contract-review-qr-nl.vue?vue&type=style&index=1&id=74b2764c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2764c",
  null
  
)

export default component.exports